import React from 'react'
import PropTypes from 'prop-types'
import { QUESTION_TYPE_MAP } from 'utils/constants'
import STRINGS from 'utils/strings'
import { Button } from 'components/UIElements'
import { getRandomQuestionId } from '../../../../../../../../../utils/getRandomQuestionId'

const MAX_SIBLING_COUNT = 30

const SiblingsPanel = props => {
  const { activeItemId, addSiblingSurveyItem, item, setActiveItemId, survey } = props
  const { siblings = {}, order } = survey
  const { sibling_id } = item
  const isAtMaxSiblings = sibling_id ? (siblings[sibling_id] || []).length === MAX_SIBLING_COUNT : false
  const index = order[0].indexOf(activeItemId)

  return (
    <div className='siblings panel'>
      <Button
        disabled={isAtMaxSiblings}
        onClick={() => {
          const newQId = getRandomQuestionId()
          const siblingId = sibling_id || getRandomQuestionId()
          addSiblingSurveyItem({
            itemType: item.type || QUESTION_TYPE_MAP.selectOne,
            newQId,
            siblingQId: activeItemId,
            siblingId,
            index,
          })
          setActiveItemId(newQId)
        }}
        link
        no-margin
        content='Add a question on the same page'
        iconBefore='fas fa-plus'
      />
      {isAtMaxSiblings ? (
        <p>{STRINGS.instrumentMaxSiblings.replace('{count}', MAX_SIBLING_COUNT)}</p>
      ) : (
        <p>{STRINGS.instrumentMaxSiblingsTooltip}</p>
      )}
    </div>
  )
}

SiblingsPanel.propTypes = {
  activeItemId: PropTypes.string,
  addSiblingSurveyItem: PropTypes.func,
  item: PropTypes.shape({
    sibling_id: PropTypes.string,
  }),
  setActiveItemId: PropTypes.func,
  survey: PropTypes.shape({
    order: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    siblings: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  }),
}

export default SiblingsPanel
